import React, {useEffect, useState} from "react";
import {makeStyles} from "@material-ui/core/styles"
import ExpandLessIcon from "@material-ui/icons/ExpandLess"
import IconButton from "@material-ui/core/IconButton"

const useStyles = makeStyles((theme) => ({
    toTop: {
        zIndex: 12,
        width: "50px",
        height: '50px',
        borderRadius: '10px',
        position: "fixed",
        bottom: "5vh",
        transition: "0.3s",
        backgroundColor: "#371B58",
        color: "#fff",
        border: '1px solid #371B58',

        "&:hover, &.Mui-focusVisible": {
            transition: "0.3s",
            color: "#371B58",
            backgroundColor: "#fff",
            border: '1px solid #371B58'
        },
        right: "2.5%"
    },
    toIcon: {
        width: "35px",
        height: "35px"
    }
}))

const ScrollToTop = ({showBelow}) => {

    const classes = useStyles();

    const [show, setShow] = useState(showBelow ? false : true)

    const handleScroll = () => {
        if (window.pageYOffset > showBelow) {
            if (!show) setShow(true)
        } else {
            if (show) setShow(false)
        }
    }
    const handleClick = () => {
        window[`scrollTo`]({top: 0, behavior: `smooth`})
    }
    useEffect(() => {
        if (showBelow) {
            window.addEventListener(`scroll`, handleScroll)
            return () => window.removeEventListener(`scroll`, handleScroll)
        }
    })
    return (
        <div>
            {show &&
            <IconButton onClick={handleClick} className={classes.toTop} aria-label="to top" component="span">
                <ExpandLessIcon className={classes.toIcon}/>
            </IconButton>
            }

        </div>
    )
}

export default ScrollToTop